import React from "react";
import PropTypes from "prop-types";
import { TableBody, TableCell, TableHead, TableRow, Grid } from "@mui/material";
import { Button } from "@totalsoft/rocket-ui";
import { useTranslation } from "react-i18next";
import DealerContactDataRowComponent from "./DealerContactDataRowComponent";
import { MinWidthTable } from "components/common/TableStyles";

export const DealerContactDataListComponent = ({
  dealer,
  contactModes,
  dealerContactInfosList,
  onPropertyChange,
  saveContactInfos,
  partnerId,
  addContactInfo,
  saveContactInfoDisabled,
  validation,
  onRowSelectionChanged
}) => {
  const { t } = useTranslation();

  return (
    <Grid container xs={{ overflowX: "auto" }}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <MinWidthTable>
          {dealerContactInfosList && dealerContactInfosList.length > 0 && (
            <TableHead>
              <TableRow>
                <TableCell style={{ paddingRight: "150px" }} colSpan={4}>
                  {t("Partner.PersonName")}
                </TableCell>
                <TableCell style={{ paddingRight: "200px" }} colSpan={4}>
                  {t("Partner.Email")}
                </TableCell>
                <TableCell style={{ textAlign: "center" }} colSpan={2}>
                  {t("Partner.MobilePhone")}
                </TableCell>
                <TableCell style={{ textAlign: "center" }} colSpan={2}>
                  {t("Partner.Default")}
                </TableCell>
                <TableCell style={{ textAlign: "center" }} colSpan={2}>
                  {t("ContactInfo.Active")}
                </TableCell>
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {dealerContactInfosList &&
              dealerContactInfosList.map((document, idx) => {
                return (
                  <DealerContactDataRowComponent
                    key={idx}
                    idx={idx}
                    contactModes={contactModes}
                    onRowSelectionChanged={onRowSelectionChanged}
                    dealerContactInfo={document}
                    contactMode={document}
                    onPropertyChange={onPropertyChange(idx)}
                    validation={validation[idx]}
                  />
                );
              })}
          </TableBody>
        </MinWidthTable>
        <Button
          id="contactInfo_addBtn"
          color="primary"
          variant="contained"
          onClick={() => addContactInfo(partnerId, dealer.dealerId)}
          sx={{ marginTop: "1.5rem" }}
        >
          {t("Add")}
        </Button>
        <Button
          id="contactInfo_saveBtn"
          color="primary"
          variant="contained"
          onClick={() => saveContactInfos(partnerId, dealerContactInfosList)}
          disabled={saveContactInfoDisabled}
          sx={{ marginLeft: ".25rem", marginTop: "1.5rem" }}
        >
          {t("Save")}
        </Button>
      </Grid>
    </Grid>
  );
};

DealerContactDataListComponent.propTypes = {
  contactModes: PropTypes.array.isRequired,
  dealerContactModes: PropTypes.array,
  dealerContactInfos: PropTypes.array,
  partnerId: PropTypes.number,
  onPropertyChange: PropTypes.func,
  addContactInfo: PropTypes.func.isRequired,
  dealerId: PropTypes.number,
  dealerContactInfosList: PropTypes.array,
  dealer: PropTypes.object.isRequired,
  saveContactInfos: PropTypes.func.isRequired,
  saveContactInfoDisabled: PropTypes.bool,
  validDefaultContactInfo: PropTypes.bool,
  validation: PropTypes.object.isRequired,
  onRowSelectionChanged: PropTypes.func
};
export default DealerContactDataListComponent;
